import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, HostListener, AfterViewChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { PaginationService, PaginationModel } from './shared';
@Component({
  selector: 'app-pagination',
  providers: [PaginationService],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges, AfterViewChecked {

  pagination: PaginationModel;
  disableButton = true;
  @Input() startIndex = 0;
  @Input() recordsPerPage = 25;
  @Input() totalRecords = 0;
  @Input() range = 2;
  @Input() visiblePageNums = 10;
  @Input() hideGoToPage = false;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('paginationcontainer') paginationcontainer;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.getPages();
  }

  constructor(public paginationService: PaginationService) { }

  ngOnInit() {
    this.getPages();
  }

  ngOnChanges() {
    this.getPages();
  }

  getPages() {
    this.pagination = this.paginationService.generatePageSeq(this.startIndex, this.recordsPerPage,
      this.totalRecords, this.visiblePageNums, this.range);
      if (this.totalRecords > this.recordsPerPage) {
        this.pagination.paginationStatus = true;
      } else {
        this.pagination.paginationStatus = false;
      }
  }

  isValidPageNumber(page: number, totalPages: number): boolean {
    return page > 0 && page <= totalPages;
  }

  ngAfterViewChecked() {
    if (this.pagination.paginationStatus) {
    const element = this.paginationcontainer.nativeElement;
    /* Here we calculate the ul's width dynamically */
    this.paginationService.getPaginationContainerWidth(element, this.pagination.isMobile);
    /* For mobile view active page set to center position */
    if (this.pagination.isMobile) {
      this.paginationService.setPositionCenter(element);
    }
    }
  }

  selectPage(page: number, event) {
    this.cancelEvent(event);
    if (this.isValidPageNumber(page, this.pagination.totalPages)) {
      this.pageChange.emit((page - 1) * this.recordsPerPage);
    }
  }

  cancelEvent(event) {
    event.preventDefault();
  }

  isValidPage(pageNo: number) {
    this.disableButton = true;
    if (this.isValidPageNumber(pageNo, this.pagination.totalPages)) {
      this.disableButton = false;
    }
  }
}
